exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.overview{max-width:1600px;margin:auto;padding-top:30px}.align-right{text-align:right}table{font-family:arial,sans-serif;border-collapse:collapse;width:100%;margin:20px 0}td,th{border:1px solid #ddd;text-align:left;padding:8px}tr:nth-child(2n){background-color:#f2dcdd}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6ab04856","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Overview.vue
// module id = 71
// module chunks = 0